"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRaceByParticipantId = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Updates a race participant by given ID (if it exists).
 *
 * Race is identified by its stringified `ObjectID`.
 * Participant is identified by their Discord ID.
 *
 * ### Updatable fields
 * - `startDate`
 * - `endDate`
 * - `dnf`
 *
 * ## Usage
 *
 * ```ts
 * const raceId: string = "5f5e555d5a578b6";
 * const memberId: string = "9674893087456";
 * const update: Partial<RacePlayer> = { dnf: true };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updateRaceByParticipantId({ raceId, memberId, update });
 * ```
 *
 * @param params.raceId   - ID of the race in which requested user participates.
 * @param params.memberId - Discord ID of the race participant to be updated.
 * @param params.update   - Fields that need to be changed.
 */
const updateRaceByParticipantId = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId, memberId, update } = params;
    const url = `${BASE_URL}/races/race/${raceId}/participants/participant/${memberId}`;
    const racePlayerResponse = yield axios_1.default.put(url, update, { validateStatus: () => true });
    const { status, data } = racePlayerResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updateRaceByParticipantId = updateRaceByParticipantId;
